<template>
  <mdb-modal fullHeight side
             position="bottom"
             direction="bottom"
             :show="show"
             @close="handleClose"
             class="quick-replies">
    <mdb-modal-header>
      <mdb-modal-title>Quick Replies</mdb-modal-title>
      <i class="fa fa-edit" @click="toggleEditable"></i>
      <i class="fa fa-plus" @click="newBoxShow"></i>
    </mdb-modal-header>
    <mdb-modal-body>
      <fieldset :disabled="loading">
      <form v-if="showNewBox" @submit.prevent="newBoxSave" class="addbox row">
        <div class="col-md-12">
          <mdb-textarea
              v-if="showNewBox"
              label="New Quick Reply"
              v-model="newBox.content"
              :rows="3"
          />
        </div>
        <div class="col-md-12 d-flex justify-content-end">
          <button type="submit" class="btn btn-default btn-sm"><i class="fas fa-save"></i></button>
          <button @click="newBoxHide" type="button" class="btn btn-default btn-sm"><i class="fas fa-times"></i></button>
        </div>
      </form>
      </fieldset>
      <mdb-list-group>
        <mdb-list-group-item :key="index" v-for="(item, index) in replies">
          <span v-if="item.shared && !item.mine" class="badge badge-light">Shared by others</span>
          <span v-if="item.shared && item.mine" class="badge badge-light">Shared with others</span>
          <pre @click.prevent="handleSelectedText(item)">{{ item.content }}</pre>
          <a title="分享此文本給其他用戶" v-if="editable && !item.shared" @click="shareItem(item.id)"><i class="fas">📤</i></a>
          <i v-if="editable && item.mine" @click="handleRemoveItem(item.id)" class="fas">🗑️</i>
        </mdb-list-group-item>
      </mdb-list-group>
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import mdbModal from "mdbvue/src/components/Modals/Modal";
import mdbTextarea from "mdbvue/src/components/Forms/MdTextarea";
import mdbModalHeader from "mdbvue/src/components/Modals/ModalHeader";
import mdbModalBody from "mdbvue/src/components/Modals/ModalBody";
import mdbModalTitle from "mdbvue/src/components/Modals/ModalTitle";
import mdbListGroup from "mdbvue/src/components/Components/ListGroup";
import mdbListGroupItem from "mdbvue/src/components/Components/ListGroupItem";
import quickRepliesService from "../Services/QuickReplies";

export default {
  name: "quick-replies",

  data() {
    return {
      loading: false,
      newBox: {
        content: ""
      },
      showNewBox: false,
      editable: false,
      replies: [],
    }
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    }
  },

  components: {
    "mdb-modal": mdbModal,
    "mdb-modal-header": mdbModalHeader,
    "mdb-modal-body": mdbModalBody,
    "mdb-modal-title": mdbModalTitle,
    mdbListGroup,
    mdbListGroupItem,
    mdbTextarea,
  },

  mounted() {
    quickRepliesService.pull().then((data) => {
      this.replies = data;
    })
  },

  watch:{
    show(val) {
      if (val) {
        quickRepliesService.pull().then((data) => {
          this.replies = data;
        });
      }
    }
  },

  methods: {
    fetchList() {
      return quickRepliesService.pull().then((data) => {
        this.replies = data;
      });
    },
    handleClose() {
      this.$emit("close");
    },
    toggleEditable() {
      this.editable = !this.editable;
    },
    handleSelectedText(item) {
      if (this.editable) {
        return;
      }
      this.$emit("selected", item.content);
    },
    handleRemoveItem(id) {
      if (confirm('Are you sure?')) {
        return quickRepliesService.remove(id)
            .then((target) => {
              return quickRepliesService.pull();
            })
            .then((data) => {
              this.replies = data;
            })
      }
    },
    shareItem(id) {
      return quickRepliesService.share(id)
          .then((target) => {
            return quickRepliesService.pull();
          })
          .then((data) => {
            this.replies = data;
          });
    },
    newBoxShow() {
      this.showNewBox = true;
    },
    newBoxHide() {
      this.newBox.content = "";
      this.showNewBox = false;
    },
    newBoxSave() {
      if (this.newBox.content.length > 0) {
        this.loading = true;
        return quickRepliesService.push(this.newBox.content)
            .then(() => {
              return quickRepliesService.pull();
            })
            .then((data) => {
              this.replies = data;
            })
            .finally(() => {
              this.loading = false;
              this.newBoxHide();
            });
      }
    }
  }
}
</script>

<style lang="scss">
.quick-replies {
  .modal-header {
    align-items: center;
  }

  .addbox {
    padding: 1em 0;
  }

  .fa {
    margin: 0 1em;
    cursor: pointer;
  }

  .modal-body {
    max-height: 60vh;
    overflow-y: auto;

    .list-group-item {
      cursor: pointer;
      gap: 1em;

      pre {
        margin-bottom: 0;
        flex: 1;
      }

      textarea {
        width: 100%;
      }

      &:hover {
        color: #155724;
        background-color: #c3e6cb;
      }
    }
  }
}
</style>
